import { Link } from "react-router-dom";
import Footer from "../components/Footer";
import LazyImage from "../components/LazyImage";
import { galleryImages } from "../data/galleryImages";

const Gallery = () => (
  <div className="flex-col lg:pb-10">
    <div className="bg-grey-600 px-10 pt-10">
      <h1 className="title romanStandard text-sm">Gallery</h1>
      <p className="pb-10 romanStandard">A small selection of our work</p>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5">
        {galleryImages.map(
          ({ number, src, srcSet, width, height, alt, to }) => (
            <Link className="px-5" to={to} key={number}>
              <LazyImage
                src={src}
                srcSet={srcSet}
                // Four columns inside px-10 with gap-5 and a px-5 link, so each
                // cell lands near a fifth of the viewport; two columns and one
                // column widen it from there.
                sizes="(min-width: 1024px) 22vw, (min-width: 768px) 45vw, 90vw"
                width={width}
                height={height}
                alt={alt}
              />
            </Link>
          )
        )}
      </div>
      <Footer />
    </div>
  </div>
);

export default Gallery;
